import React, { useEffect, useState } from 'react';
import Layout from '../../../../layout';
import { EstimatedAmountAccountPage } from '../style';
import SelectBox from 'components/SelectBox';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { requestApi } from '../../../../utils/request';
import dayjs from 'dayjs';
import { CheckBoxCustom } from 'components/CheckBox/style';
import { useUI } from '../../../../contexts/UIContext';

const EstimatedAmountAccount = () => {
  const { setContextLoading, setModalData } = useUI();
  const [mallAccountData, setMallAccountData] = useState({} | null);
  const [filterAccount, setFilterAccount] = useState([]);
  const [params, setParams] = useState({
    deliverSuccessAmountYn: 'Y',
    paymentBankCd: null,
    paymentAccountHolder: null,
    paymentBankAccountNumber: null,
    accountSearchYn: 'N',
  });

  const onChangeCheckBox = event => {
    const { checked } = event.target;
    setParams(prevParams => ({
      ...prevParams,
      deliverSuccessAmountYn: checked ? 'Y' : 'N',
    }));
  };

  const onChangeSelectAccount = e => {
    const selectedValue = JSON.parse(e.target.value) || {};

    // selectedValue가 빈 객체일 경우 0으로 간주
    if (!selectedValue || Object.keys(selectedValue).length === 0) {
      setParams(prevParams => ({
        ...prevParams,
        accountSearchYn: 'N',
        paymentBankCd: null,
        paymentAccountHolder: null,
        paymentBankAccountNumber: null,
      }));
    } else {
      const { paymentBankCd, paymentAccountHolder, paymentBankAccountNumber } =
        selectedValue;
      setParams(prevParams => ({
        ...prevParams,
        accountSearchYn: 'Y',
        paymentBankCd,
        paymentAccountHolder,
        paymentBankAccountNumber,
      }));
    }
  };

  const fetchManageAccount = async ({
    paymentBankCd,
    paymentAccountHolder,
    paymentBankAccountNumber,
    accountSearchYn,
    deliverSuccessAmountYn,
  }) => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider/manage/accounts/settlement-scheduled/list`,
        method: 'GET',
        params: {
          paymentBankCd: paymentBankCd,
          paymentAccountHolder: paymentAccountHolder,
          paymentBankAccountNumber: paymentBankAccountNumber,
          accountSearchYn: accountSearchYn,
          deliverSuccessAmountYn: deliverSuccessAmountYn,
        },
      });

      if (res.success) {
        setMallAccountData(res.data?.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setContextLoading(false);
    }
  };

  const fetchAccountFilter = async () => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider/manage/accounts/list`,
        method: 'GET',
      });

      const mappedData = res.data.result.map(item => ({
        label: `${
          item.paymentBankNm && item.paymentBankNm !== '미확인'
            ? item.paymentBankNm
            : '은행 확인불가'
        }/${
          item.paymentAccountHolder && item.paymentAccountHolder !== '미확인'
            ? item.paymentAccountHolder
            : '예금주 확인불가'
        }/${
          item.paymentBankAccountNumber &&
          item.paymentBankAccountNumber !== '99999999999999'
            ? item.paymentBankAccountNumber
            : '계좌번호 확인불가'
        }`,
        value: JSON.stringify({
          paymentBankCd: item.paymentBankCd,
          paymentAccountHolder: item.paymentAccountHolder,
          paymentBankAccountNumber: item.paymentBankAccountNumber,
        }),
      }));
      mappedData.unshift({ label: '전체', value: 0 });
      setFilterAccount(mappedData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchAccountFilter();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await fetchManageAccount(params);
    })();
  }, [params]);

  return (
    <Layout pageTitle="계좌별 정산예정금">
      <EstimatedAmountAccountPage>
        <section className="accountInfo">
          <p className="title">
            계좌 정보{' '}
            <button
              type="button"
              onClick={() => {
                setModalData({
                  textAlign: 'left',
                  fontWeight: 400,
                  contents: `계좌정보는 판매몰별 계좌정보 제공 방식이 상이하여 동일 계좌라도 다르게 표시될 수 있습니다.\n일부 정보가 제공되지 않거나 확인이 어려운 경우 '확인불가'로 표시됩니다. `,
                });
              }}
            >
              <FeatherIcon
                icon="help-circle"
                size={16}
                stroke="#737171"
                strokeWidth={2}
              />
            </button>
          </p>
          <SelectBox
            optionList={filterAccount}
            optionHandleChange={onChangeSelectAccount}
            isNotDisabled={true}
            noPadding={true}
            $formStyle
          />
        </section>
        <section className="estimatedInfo">
          <p className="title">정산예정금 정보</p>
          {!mallAccountData ? (
            <p className="noList">연동 가능한 정산예정금이 없습니다.</p>
          ) : (
            <>
              {mallAccountData.minScheduledSettlementDate !== '' && (
                <p className="amountDate">
                  정산 예정 기간{' '}
                  {dayjs(mallAccountData.minScheduledSettlementDate).format(
                    'YYYY.MM.DD'
                  )}{' '}
                  ~
                  {dayjs(mallAccountData.maxScheduledSettlementDate).format(
                    'YYYY.MM.DD'
                  )}
                </p>
              )}

              {mallAccountData.allAccountsSettlementScheduledInfo && (
                <ul>
                  {mallAccountData.allAccountsSettlementScheduledInfo.map(
                    (item, index) => {
                      return (
                        <li key={index}>
                          <dl>
                            <dt>
                              {item.paymentBankNm &&
                              item.paymentBankNm !== '미확인'
                                ? item.paymentBankNm
                                : '은행 확인불가'}
                              /
                              {item.paymentAccountHolder &&
                              item.paymentAccountHolder !== '미확인'
                                ? item.paymentAccountHolder
                                : '예금주 확인불가'}
                              /
                              {item.paymentBankAccountNumber &&
                              item.paymentBankAccountNumber !== '99999999999999'
                                ? item.paymentBankAccountNumber
                                : '계좌번호 확인불가'}
                              <br />
                              <span>{item.mallName}</span>
                            </dt>
                            <dd>
                              {item.accountSettlementScheduledAmt?.toLocaleString()}{' '}
                              원
                            </dd>
                          </dl>
                        </li>
                      );
                    }
                  )}
                </ul>
              )}
              {mallAccountData.accountOptionsSettlementScheduledInfo && (
                <ul className="byAccount">
                  {mallAccountData.accountOptionsSettlementScheduledInfo.map(
                    (item, index) => {
                      return (
                        <li key={index}>
                          <dl>
                            <dt>{item.mallName}</dt>
                            <dd>
                              {item.mallSettlementScheduledAmount?.toLocaleString()}{' '}
                              원
                            </dd>
                          </dl>
                        </li>
                      );
                    }
                  )}
                </ul>
              )}
              <dl className="total">
                <dt>합계</dt>
                <dd>
                  {mallAccountData.sumSettlementScheduledAmt?.toLocaleString()}{' '}
                  원
                </dd>
              </dl>
            </>
          )}

          <CheckBoxCustom className="checkBox">
            <input
              type="checkbox"
              id="deliverSuccessAmountYn"
              defaultChecked
              onChange={onChangeCheckBox}
            />
            <FeatherIcon
              icon="check"
              size={14}
              stroke="white"
              className="checkIcon"
            />
            <span>배송완료금액 포함</span>
            <button
              type="button"
              onClick={() => {
                setModalData({
                  textAlign: 'left',
                  fontWeight: 400,
                  contents: `'배송완료금액'은 배송 완료 상태로 확정 된 날짜를 기준으로 정산 예정일을 임의로 산출한 금액이므로, 참고용으로만 활용해 주세요.`,
                });
              }}
            >
              <FeatherIcon
                icon="help-circle"
                size={16}
                stroke="#737171"
                strokeWidth={2}
              />
            </button>
          </CheckBoxCustom>
        </section>
      </EstimatedAmountAccountPage>
    </Layout>
  );
};

export default EstimatedAmountAccount;
